/**
 * Created by Denis Kuzin on 18 june 2026
 */

cc.FireEffect = function (effect, target) {
    cc.ActionInstant.prototype.constructor.call(this);

    this.effect = effect;
    this.effectTarget = target;
};

cc.FireEffect.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.FireEffect,

    update: function () {
        if (this.effectTarget && !this.effectTarget.visible) {
            return;
        }

        cleverapps.effects.fire(this.effect);
    },

    _autoFinalize: function () {}
});
